import { type MutableRefObject, useEffect, useState } from 'react'

export function useSyncPopoverState(ref: MutableRefObject<HTMLElement | null>) {
	const [isOpen, setIsOpen] = useState(false)

	useEffect(() => {
		const popover = ref.current

		const listener = (event: ToggleEvent) =>
			setIsOpen(event.newState === 'open')

		// @ts-expect-error
		popover?.addEventListener('toggle', listener)

		// @ts-expect-error
		return () => popover?.removeEventListener('toggle', listener)
	}, [ref])

	return isOpen
}
